import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { apiPost } from '../../services/api';

export default function GoogleCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState(false);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (!code || !state) {
      navigate('/login?error=oauth_failed', { replace: true });
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const res = await apiPost('/api/v1/auth/google/callback', { code, state });
        const data = await res.json().catch(() => ({}));

        if (cancelled) return;

        if (!res.ok) {
          setError(true);
          navigate('/login?error=oauth_failed', { replace: true });
          return;
        }

        const u = data?.data?.user;
        const t = data?.data?.token;
        if (u && t) {
          login(u, t);
          navigate('/dashboard', { replace: true });
          return;
        }

        setError(true);
        navigate('/login?error=oauth_failed', { replace: true });
      } catch {
        if (!cancelled) {
          setError(true);
          navigate('/login?error=oauth_failed', { replace: true });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div className="rwm-auth bg-white">
        <div
          className="rwm-auth__card py-5 text-center text-muted"
          data-testid="rwm-oauth-callback-error"
        >
          Sign-in failed. Redirecting…
        </div>
      </div>
    );
  }

  return (
    <div className="rwm-auth bg-white">
      <div
        className="rwm-auth__card py-5 text-center text-muted"
        data-testid="rwm-oauth-callback-loading"
      >
        <div className="spinner-border text-info mb-3" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
        <p className="mb-0">Completing sign-in…</p>
      </div>
    </div>
  );
}
